import React from 'react'
import {makeStyles} from "@material-ui/core";
import googlePlay from './images/google-play.svg'
import appStore from './images/app-store.svg'


const useStyles = makeStyles((theme) => ({
    titleApplication: {
        marginTop: '44px !important',
        marginBottom: '16px !important',
        textAlign: 'center',
        color: '#3378A5'
    },
    wrapperApplication: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 16,
        paddingBottom: '24px',
        '& img': {
            cursor: 'pointer'
        }
    }
}))

const Application = ({column = false}) => {
    const cl = useStyles();

    const handleRouter = (url) => {
            window.open(url, '_blank')

    }

    return (<div>
        <p className={cl.titleApplication}>Завантажуй наш застосунок</p>
        <div className={cl.wrapperApplication} style={{flexDirection: column ? 'column' : 'row'}}>
            <img onClick={() => handleRouter(
                'https://play.google.com/store/apps/details?id=com.mak.elab')} src={googlePlay}
                 alt="google-play"/>
            <img onClick={() => handleRouter(
                'https://apps.apple.com/ua/app/esculab-%D0%BC%D0%B5%D0%B4%D0%B8%D1%87%D0%BD%D0%B0-%D0%BB%D0%B0%D0%B1%D0%BE%D1%80%D0%B0%D1%82%D0%BE%D1%80%D1%96%D1%8F/id6757756254?l=uk'
            )} src={appStore} alt="app-store"/>
        </div>
    </div>)
}

export default Application